export const HOME_KEY = 'home';
export const PRODUCTS_KEY = 'products';
export const SINGLE_PRODUCT_KEY = 'product';
export const QUERY_COMMENTS_KEY = 'comments';
export const QUERY_PROFILE_KEY = 'profile';
export const QUERY_TAG_KEY = 'tags';
export const USER_ADDRESSES = 'user-addresses';
export const CART = 'carts';
export const WISHLIST_KEY = 'wishlist';
export const USER_ORDERS = 'user-orders';
export const USER_PROFILE = 'user-profile';
export const SHIPPING_RULES = 'shipping-rules';
export const SUBCATEGORIES_KEY = 'subcategories';
export const REVIEW_KEY = 'product-reviews';
export const PRODUCT_GLOBAL_SEARCH_KEY = 'productglobal-search';
export const ORDER_INVOICE_KEY = 'order-invoice';

